<template>

  <body class="webcheck-body">
    <img src="https://cdn.prod.website-files.com/67ae209f895ca2988224af8b/67ae25d58dc3c526a330d9b9_Logo.svg"
      loading="lazy" width="161" alt="" class="webcheck-logo">
    <div class="webcheck-title"><strong class="bold-text">Analyze Your Website</strong><br></div>
    <div class="webcheck-form-block w-form" v-if="!isLoading && !apiResponse">
      <div name="email-form" data-name="Email Form" class="webcheck-form" aria-label="Email Form">
        <input class="webcheck-input w-input" maxlength="256" placeholder="Enter your URL (e.g. www.example.com)"
          type="text" v-model="url">
        <div class="webcheck-submit-btn w-button" @click="analyzeUrl(url)">Analyze</div>
        <div>
        </div>
      </div>
      <div class="webcheck-small-text">
        <a href="https://policies.google.com/terms?hl=en" target="_blank"
          class="webcheck-external-link">
          <span>Google</span>
        </a> Recaptcha and PageSpeed API are used for security and performance analysis
      </div>
      <div class="webcheck-small-text" style="color: salmon" v-if="error">
         Error Analyzing URL: {{ error }}
      </div>
    </div>


    <div class="webcheck-stats-wrapper" v-if="apiResponse && !error && !isLoading">
      <div class="webcheck-gauge-wrapper">
        <div class="webcheck-gauge-outer"></div>
        <div class="webcheck-gauge-outer-inner" :style="{ transform: 'rotate(' + (totalScore / 100) / 2 + 'turn)' }">
        </div>
        <div class="webcheck-gauge-center-wrapper">
          <div class="webcheck-gauge-center-cirlce">
            <div class="webcheck-gauge-score large">{{ totalScore }}</div>
            <div class="webcheck-gauge-score">Overall Score</div>
          </div>
        </div>
      </div>
      <div class="webcheck-main-stats">
        <div class="webcheck-stat-website">{{ url }}</div>
        <div class="webcheck-stat-text-wrapper">
          <div class="webcheck-stat-text">SEO Score {{ (seoScore * 100).toFixed(0) }}%</div>
          <div class="webcheck-stat-bar-wrapper">
            <div class="webcheck-stat-bar-fill" :style="{ width: seoScore * 100 + '%' }"></div>
          </div>
        </div>
        <div class="webcheck-stat-text-wrapper">
          <div class="webcheck-stat-text">Accessibility Score {{ (accessabilityScore * 100).toFixed(0) }}%</div>
          <div class="webcheck-stat-bar-wrapper">
            <div class="webcheck-stat-bar-fill" :style="{ width: accessabilityScore * 100 + '%' }"></div>
          </div>
        </div>
        <div class="webcheck-stat-text-wrapper">
          <div class="webcheck-stat-text">Performance Score {{ (performanceScore * 100).toFixed(0) }}%</div>
          <div class="webcheck-stat-bar-wrapper">
            <div class="webcheck-stat-bar-fill" :style="{ width: performanceScore * 100 + '%' }"></div>
          </div>
        </div>
        <div class="webcheck-stat-text-wrapper">
          <div class="webcheck-stat-text">Best Practices Score {{ (bestPracticesScore * 100).toFixed(0) }}%</div>
          <div class="webcheck-stat-bar-wrapper">
            <div class="webcheck-stat-bar-fill" :style="{ width: bestPracticesScore * 100 + '%' }"></div>
          </div>
        </div>
      </div>
      <div ref="results"></div>
      <div class="webcheck-stat-nav">
        <div class="webcheck-stat-nav-link" :class="{ selected: activeTab == 'seo' }" @click="activeTab = 'seo'">
          <span class="webcheck-stat-nav-link-icon">travel_explore</span>
          <span class="webcheck-stat-nav-link-text">SEO</span>
        </div>
        <div class="webcheck-stat-nav-link" :class="{ selected: activeTab == 'access' }" @click="activeTab = 'access'">
          <span class="webcheck-stat-nav-link-icon">accessibility_new</span>
          <span class="webcheck-stat-nav-link-text">Accessability</span>
        </div>
        <div class="webcheck-stat-nav-link" :class="{ selected: activeTab == 'performance' }"
          @click="activeTab = 'performance'">
          <span class="webcheck-stat-nav-link-icon">manufacturing</span>
          <span class="webcheck-stat-nav-link-text">Performance</span>
        </div>
        <div class="webcheck-stat-nav-link" :class="{ selected: activeTab == 'practices' }"
          @click="activeTab = 'practices'">
          <span class="webcheck-stat-nav-link-icon">done_all</span>
          <span class="webcheck-stat-nav-link-text">Practice</span>
        </div>
      </div>
      <!-- SEO Audit -->
      <div class="webcheck-stat-block-wrapper" v-if="activeTab === 'seo'">
        <div class="webcheck-stat-block-title">SEO Audit<br></div>

        <div class="webcheck-stat-block-text-wrapper" v-for="audit in seoAudits" :key="audit.id"
          :class="{ fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }">

          <div v-if="audit.score !== null">
            <div class="webcheck-stat-block-subtitle">{{ audit.title }}</div>
            <div class="webcheck-stat-block-text">{{ audit.description }}</div>

            <div v-if="audit.scoreDisplayMode === 'binary'">
              <div class="webcheck-stat-block-score-wrapper" v-if="audit.score === 1">
                Score: <span class="webcheck-stat-block-text-pass-score">Pass</span>
              </div>
              <div class="webcheck-stat-block-score-wrapper" v-else>
                <div class="webcheck-stat-block-score-text">Score:</div>
                <div class="webcheck-stat-block-text-fail-score">Fail</div>
              </div>
            </div>

            <div v-else-if="audit.scoreDisplayMode === 'numeric'">
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}% ({{ audit.numericValue }} {{ audit.numericUnit }})
              </div>
            </div>
            <div v-else>
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}%
              </div>
            </div>

            <div class="webcheck-stat-detail-wrapper"
              v-if="audit.details && audit.details.items && audit.details.items.length">
              <div class="webcheck-detail-row">
                <div class="webcheck-stat-column-head-text" v-for="heading in audit.details.headings"
                  :key="heading.key">
                  {{ heading.label }}
                </div>
              </div>
              <div class="webcheck-detail-row" v-for="(item, index) in audit.details.items" :key="index">
                <div class="webcheck-stat-value" style="white-space: pre-wrap; font-family: monospace;"
                  v-for="heading in audit.details.headings" :key="heading.key">
                  {{ showDetailText(item[heading.key]) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Accessability Audit -->
      <div class="webcheck-stat-block-wrapper" v-if="activeTab === 'access'">
        <div class="webcheck-stat-block-title">Accessability Audit<br></div>

        <div class="webcheck-stat-block-text-wrapper" v-for="audit in accessabilityAudits" :key="audit.id"
          :class="{ fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }">

          <div v-if="audit.score !== null">
            <div class="webcheck-stat-block-subtitle">{{ audit.title }}</div>
            <div class="webcheck-stat-block-text">{{ audit.description }}</div>

            <div v-if="audit.scoreDisplayMode === 'binary'">
              <div class="webcheck-stat-block-score-wrapper" v-if="audit.score === 1">
                Score: <span class="webcheck-stat-block-text-pass-score">Pass</span>
              </div>
              <div class="webcheck-stat-block-score-wrapper" v-else>
                <div class="webcheck-stat-block-score-text">Score:</div>
                <div class="webcheck-stat-block-text-fail-score">Fail</div>
              </div>
            </div>

            <div v-else-if="audit.scoreDisplayMode === 'numeric'">
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}% ({{ audit.numericValue }} {{ audit.numericUnit }})
              </div>
            </div>
            <div v-else>
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}%
              </div>
            </div>

            <div class="webcheck-stat-detail-wrapper"
              v-if="audit.details && audit.details.items && audit.details.items.length">
              <div class="webcheck-detail-row">
                <div class="webcheck-stat-column-head-text" v-for="heading in audit.details.headings"
                  :key="heading.key">
                  {{ heading.label }}
                </div>
              </div>
              <div class="webcheck-detail-row" v-for="(item, index) in audit.details.items" :key="index">
                <div class="webcheck-stat-value" style="white-space: pre-wrap; font-family: monospace;"
                  v-for="heading in audit.details.headings" :key="heading.key">
                  {{ showDetailText(item[heading.key]) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Performance Audit -->
      <div class="webcheck-stat-block-wrapper" v-if="activeTab === 'performance'">
        <div class="webcheck-stat-block-title">Performance Audit<br></div>

        <div class="webcheck-stat-block-text-wrapper" v-for="audit in performanceAudits" :key="audit.id"
          :class="{ fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }">

          <div v-if="audit.score !== null">
            <div class="webcheck-stat-block-subtitle">{{ audit.title }}</div>
            <div class="webcheck-stat-block-text">{{ audit.description }}</div>

            <div v-if="audit.scoreDisplayMode === 'binary'">
              <div class="webcheck-stat-block-score-wrapper" v-if="audit.score === 1">
                Score: <span class="webcheck-stat-block-text-pass-score">Pass</span>
              </div>
              <div class="webcheck-stat-block-score-wrapper" v-else>
                <div class="webcheck-stat-block-score-text">Score:</div>
                <div class="webcheck-stat-block-text-fail-score">Fail</div>
              </div>
            </div>

            <div v-else-if="audit.scoreDisplayMode === 'numeric'">
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}% ({{ audit.numericValue }} {{ audit.numericUnit }})
              </div>
            </div>
            <div v-else>
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}%
              </div>
            </div>

            <div class="webcheck-stat-detail-wrapper"
              v-if="audit.details && audit.details.items && audit.details.items.length">
              <div class="webcheck-detail-row">
                <div class="webcheck-stat-column-head-text" v-for="heading in audit.details.headings"
                  :key="heading.key">
                  {{ heading.label }}
                </div>
              </div>
              <div class="webcheck-detail-row" v-for="(item, index) in audit.details.items" :key="index">
                <div class="webcheck-stat-value" style="white-space: pre-wrap; font-family: monospace;"
                  v-for="heading in audit.details.headings" :key="heading.key">
                  {{ showDetailText(item[heading.key]) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Practice Audit -->
      <div class="webcheck-stat-block-wrapper" v-if="activeTab === 'practices'">
        <div class="webcheck-stat-block-title">Best Practices Audit<br></div>

        <div class="webcheck-stat-block-text-wrapper" v-for="audit in bestPracticesAudits" :key="audit.id"
          :class="{ fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }">

          <div v-if="audit.score !== null">
            <div class="webcheck-stat-block-subtitle">{{ audit.title }}</div>
            <div class="webcheck-stat-block-text">{{ audit.description }}</div>

            <div v-if="audit.scoreDisplayMode === 'binary'">
              <div class="webcheck-stat-block-score-wrapper" v-if="audit.score === 1">
                Score: <span class="webcheck-stat-block-text-pass-score">Pass</span>
              </div>
              <div class="webcheck-stat-block-score-wrapper" v-else>
                <div class="webcheck-stat-block-score-text">Score:</div>
                <div class="webcheck-stat-block-text-fail-score">Fail</div>
              </div>
            </div>

            <div v-else-if="audit.scoreDisplayMode === 'numeric'">
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}% ({{ audit.numericValue }} {{ audit.numericUnit }})
              </div>
            </div>
            <div v-else>
              <div class="webcheck-stat-block-score-wrapper">
                Score: {{ (audit.score * 100).toFixed(2) }}%
              </div>
            </div>

            <div class="webcheck-stat-detail-wrapper"
              v-if="audit.details && audit.details.items && audit.details.items.length">
              <div class="webcheck-detail-row">
                <div class="webcheck-stat-column-head-text" v-for="heading in audit.details.headings"
                  :key="heading.key">
                  {{ heading.label }}
                </div>
              </div>
              <div class="webcheck-detail-row" v-for="(item, index) in audit.details.items" :key="index">
                <div class="webcheck-stat-value" style="white-space: pre-wrap; font-family: monospace;"
                  v-for="heading in audit.details.headings" :key="heading.key">
                  {{ showDetailText(item[heading.key]) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="webcheck-scanning-animation-wrapper" v-if="isLoading && !error">
      <img
        src="https://cdn.prod.website-files.com/67ae209f895ca2988224af8b/67eda5d3e4309699665c6227_Animation%20-%201743627601433.gif"
        loading="lazy" alt="" class="webcheck-animation-gif">
      <div class="webcheck-scanning-text">
        <div class="webcheck-scanning-url">Analyzing {{ url }}</div>
        <div class="webcheck-small-text">This might take up to two minutes</div>
      </div>
    </div>
    <div class="webcheck-contact-us-btn" @click="showContact = true">
      <div class="webcheck-contact-us-btn-text">Contact Us</div>
    </div>
    <div class="contact-wrapper" v-if="showContact">
      <div class="webcheck-contact-form-wrapper w-form">
        <div class="webcheck-contact-form-close-btn" @click="showContact = false">close</div>
        <div class="webcheck-contact-form-title">Contact Us</div>
        <div class="webcheck-contact-form-subtitle">Reach out to us with any questions.<br></div>
        <form aria-label="Contact Form" ref="contactForm" @submit="submitForm">
          <label for="name">Name/Organization *</label>
          <input class="webcheck-contact-input w-input" autofocus="true" maxlength="256" name="name_input"
            data-name="name_input" placeholder="Enter your name or organization" type="text" required="true">
          <label for="email">Email *</label>
          <input class="webcheck-contact-input w-input" autofocus="true" maxlength="256" data-name="email_input"
            name="email_input" placeholder="Enter your email address" type="email" id="email" required="true">
          <label for="field">Message</label>
          <textarea autofocus="true" placeholder="Type your message" maxlength="5000" data-name="message_input"
            name="message_input" class="webcheck-contact-input text-area w-input" required="true"></textarea>
          <input type="submit" class="webcheck-contact-form-btn w-button" value="Submit" v-if="!formIsSending">
          <div>

          </div>
        </form>
        <div v-if="formIsSending">Sending...</div>
        <div class="webcheck-contact-done-wrapper" v-if="formIsSent && !formIsSending">
          <div class="webcheck-form-sent-title icon">task</div>
          <div class="webcheck-form-sent-title">Thank you!</div>
          <div class="text-block-2">We received your message and we'll get back to you as soon as we can</div>
          <div class="webcheck-contact-form-finish-send-btn">
            <div class="webcheck-contact-us-btn-text" @click="showContact = false">Close</div>
          </div>
        </div>

      </div>
    </div>
  </body>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ref } from 'vue'

const sectionRefEl = ref<HTMLElement | null>(null)

export default defineComponent({
  name: 'HomeView',
  components: {
  },

  data() {
    return {
      formIsSending: false,
      formIsSent: false,
      formSentSuccessfully: false,
      showContact: false,
      printing: false,
      activeTab: 'seo',
      totalScore: 0,
      url: '',
      isLoading: false,
      error: '',
      reportCategories: null as any,
      reportAudits: null as any,
      apiResponse: null as any,
      accessabilityScore: 0,
      performanceScore: 0,
      seoScore: 0,
      bestPracticesScore: 0,
      accessabilityAudits: null as any,
      performanceAudits: null as any,
      seoAudits: null as any,
      bestPracticesAudits: null as any,
    }
  },
  mounted() {

  },
  watch: {
    activeTab(newVal, oldVal) {
      const target = this.$refs.results as HTMLElement;
      if (target) {
        // Scrolls smoothly to the element
        target.scrollIntoView();
      }
    }
  },
  computed: {
    gaugeColor() {
      const value = this.totalScore / 100;
      // Interpolate between red (#FF5733) and green (#50C878)
      const r = Math.round(255 + (80 - 255) * value);
      const g = Math.round(87 + (200 - 87) * value);
      const b = Math.round(51 + (120 - 51) * value);
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
  methods: {
    showDetailText(txt: string) {
      try {
        const json = JSON.parse(txt);
        const jsonText = JSON.stringify(json, null, 2);
        return jsonText
      } catch (e) {
        return txt;
      }
    },


    async submitForm(event: Event) {
      this.formIsSending = true;
      const form = this.$refs.contactForm as HTMLFormElement;
      // Check if the form is valid
      if (!form.checkValidity()) {
        // Display native validation messages
        form.reportValidity();
        // Stop further execution
        return;
      }
      event.preventDefault();

      // Obtain the reCAPTCHA token
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('contact');

      // Build the POST payload
      const formData = new FormData(form);
      formData.append('token', token);

      // Submit the form data to your PHP backend
      const response = await fetch('https://modulemind.ca/php/send.php', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Process the response as needed
        const data = await response.json();
        if (data.status === "success") {
          this.formSentSuccessfully = true;
          this.formIsSent = true;

        }
      } else {
        this.formSentSuccessfully = false;
        this.formIsSent = true;
      }
      this.formIsSending = false;
    },
    async analyzeUrl(url: string) {
      if (!this.url) {
        return;
      }
      // make sure to add https:// to the url if it's not already there
      //swap http:// for https://
      this.url = this.url.replace(/^http:\/\//i, 'https://');
      //make sure to add https:// to the url if it's not already there and swap http:// for https://  
      if (!this.url.startsWith('https://')) {
        this.url = 'https://' + this.url;
      }
      try {
        this.isLoading = true;
        this.error = '';
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('analyze')
        //console.log('Obtained reCAPTCHA token:', token)

        // Build the POST payload
        const formData = new FormData();
        formData.append('url', this.url);
        formData.append('token', token);

        const response = await fetch('https://modulemind.ca/php/seo_check.php', {
          method: 'POST',
          body: formData
        });


        if (response.ok) {
          const data = await response.json()
          if (data.status === 'error') {
            this.error = data.message
          } else {
            this.apiResponse = data;
            this.reportCategories = data.lighthouseResult.categories
            this.reportAudits = data.lighthouseResult.audits
            this.accessabilityScore = data.lighthouseResult.categories.accessibility.score
            this.performanceScore = data.lighthouseResult.categories.performance.score
            this.bestPracticesScore = data.lighthouseResult.categories['best-practices'].score
            this.seoScore = data.lighthouseResult.categories.seo.score
            const totalCategoryScores = this.accessabilityScore + this.performanceScore + this.bestPracticesScore + this.seoScore;
            this.totalScore = parseFloat((totalCategoryScores / 4).toFixed(2)) * 100


            // SEO Audits
            const seoAuditIds = data.lighthouseResult.categories.seo.auditRefs
            // filter audit refs with weight > 0
            const valuableSeoAudits = seoAuditIds.filter((audit: { weight: number; }) => audit.weight > 0).map((audit: { id: any; }) => audit.id)
            // populate seoAudits array with audits from reportsAudits object that have the same id as the valuableSeoAudits
            this.seoAudits = valuableSeoAudits.map((auditId: any) => this.reportAudits[auditId])
            //console.log(this.seoAudits)

            // Accessability Audits
            const accessabilityAuditIds = data.lighthouseResult.categories.accessibility.auditRefs
            // filter audit refs with weight > 0
            const valuableAccessabilityAudits = accessabilityAuditIds.filter((audit: { weight: number; }) => audit.weight > 0).map((audit: { id: any; }) => audit.id)
            // populate accessabilityAudits array with audits from reportsAudits object that have the same id as the valuableAccessabilityAudits
            this.accessabilityAudits = valuableAccessabilityAudits.map((auditId: any) => this.reportAudits[auditId])
            //console.log(this.accessabilityAudits)

            // Performance Audits
            const performanceAuditIds = data.lighthouseResult.categories.performance.auditRefs
            // filter audit refs with weight > 0
            const valuablePerformanceAudits = performanceAuditIds.filter((audit: { weight: number; }) => audit.weight > 0).map((audit: { id: any; }) => audit.id)
            // populate performanceAudits array with audits from reportsAudits object that have the same id as the valuablePerformanceAudits
            this.performanceAudits = valuablePerformanceAudits.map((auditId: any) => this.reportAudits[auditId])
            //console.log(this.performanceAudits)

            // best practices Audits
            const bestPracticesAuditIds = data.lighthouseResult.categories['best-practices'].auditRefs
            // filter audit refs with weight > 0
            const valuableBestPracticesAudits = bestPracticesAuditIds.filter((audit: { weight: number; }) => audit.weight > 0).map((audit: { id: any; }) => audit.id)
            // populate bestPracticesAudits array with audits from reportsAudits object that have the same id as the valuableBestPracticesAudits
            this.bestPracticesAudits = valuableBestPracticesAudits.map((auditId: any) => this.reportAudits[auditId])
            //console.log(this.bestPracticesAudits)


          }
          // console.log('Server response:', data)
        } else {
          // console.error('Server error:', response)
        }
        this.isLoading = false;
        /*
        console.log("debug", {
          'api response': this.apiResponse,
          'isLoading': this.isLoading,
          'error': this.error
        })
        */
      } catch (error) {
        //console.error('Error:', error)
        this.isLoading = false;
        this.error = 'The server encountered an error. Please try again later.';
      }
    },
    downloadReport() {
      // Implement download logic here
      this.printing = true
      setTimeout(() => {
        window.print()
        this.printing = false
      }, 100);
    }
  }
});
</script>
<style scoped>
.gauge-outer {
  width: 100%;
  max-width: 250px;
}

.gauge-inner {
  width: 100%;
  background-color: gray;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
  position: relative;
  border-top-left-radius: 100% 200%;
  border-top-right-radius: 100% 200%;
}

.gauge-fill {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: 100%;

  transform-origin: center top;
  transform: rotate(0turn);
  transition: transform 0.2s ease-out;
}

.gauge-cover {
  width: 75%;
  height: 150%;
  background: white;
  top: 25%;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 25%;
  box-sizing: border-box;
  font-family: 'Lexend Deca', sans-serif;
  font-size: 1.5rem;
  color: #333;
}
</style>
